export const CODE_FREE_LIMIT = 10000;
export const CODE_PAID_LIMIT = 20000;
